import { Formik } from 'formik';
import { useSnackbar } from 'notistack';
import outOfOfficeValidationSchema from './outOfOfficeValidationSchema';
import { useAuth } from '../../../auth';
import { apiClient } from '../../../api-client';
import OutOfOfficeForm from './OutOfOfficeForm';
import { createTempoWorklog } from '../../../utils/functions/tempoHelpers';

const withTime = (value, hours = 10, minutes = 0, seconds = 0, ms = 0) => {
  const d = value instanceof Date ? new Date(value) : new Date(value);
  d.setHours(hours, minutes, seconds, ms);
  return d;
};

const submitOutOfOfficeRequest = async (values, user, getToken, enqueueSnackbar) => {
  const startAt10 = withTime(values.startDate);
  const endAt10 = withTime(values.endDate);

  try {
    const result = await apiClient('POST', '/requests/out-of-office', getToken, {
      startDate: startAt10.toISOString(),
      endDate: endAt10.toISOString(),
      description: values.description,
      requestType: values.requestType,
    });

    if (result?.status !== 'OK') {
      throw new Error(result?.message || 'Request failed');
    }

    enqueueSnackbar('Out of office request successfully submitted', {
      variant: 'success',
    });

    createTempoWorklog(
      getToken,
      user.email,
      values.startDate,
      values.endDate,
      values.requestType.replace(/\s+/g, '-').toLowerCase(), // "sick-leave", "patron-saint-day" ...
    );
  } catch (err) {
    enqueueSnackbar(err.message || 'Error when submitting out of office request', {
      variant: 'error',
    });
    console.error('Out of office request submission failed: ', err);
  }
};

const OutOfOfficeFormContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { user, getToken } = useAuth();

  return (
    <Formik
      enableReinitialize
      initialErrors={[]}
      validationSchema={outOfOfficeValidationSchema}
      initialValues={{}}
      onSubmit={async (values, { resetForm }) => {
        await submitOutOfOfficeRequest(values, user, getToken, enqueueSnackbar);
        resetForm();
      }}
    >
      {form => <OutOfOfficeForm formProps={form} />}
    </Formik>
  );
};

export default OutOfOfficeFormContainer;
